var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinIconNoColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06938 7C6.92684 7 6 7.89862 6 9.00572V32.9949C6 34.1021 6.92695 35 8.06938 35H31.9306C33.0736 35 34 34.102 34 32.9946V9.00572C34 7.89862 33.0736 7 31.9306 7H8.06938ZM14.5087 17.8267V30.4324H10.3188V17.8267H14.5087ZM14.7849 13.9282C14.7849 15.1379 13.8754 16.1059 12.4146 16.1059L12.3872 16.1058C10.9809 16.1058 10.0718 15.1378 10.0718 13.9281C10.0718 12.691 11.0084 11.75 12.4424 11.75C13.8754 11.75 14.7575 12.691 14.7849 13.9282ZM21.0175 30.4324H16.8279C16.8279 30.4324 16.8828 19.0097 16.8281 17.8271H21.0178V19.6114C21.5748 18.7527 22.5716 17.5312 24.794 17.5312C27.5506 17.5312 29.6173 19.3329 29.6173 23.2047V30.4324H25.4278V23.6894C25.4278 21.9946 24.8211 20.8388 23.3054 20.8388C22.1477 20.8388 21.4583 21.6183 21.1555 22.3713C21.0448 22.6401 21.0175 23.0173 21.0175 23.3936V30.4324Z",
    fill: "#2AAD75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconNoColorIcon);
export default __webpack_public_path__ + "static/media/linkedinIconNoColorIcon.0fc54599.svg";
export { ForwardRef as ReactComponent };